import { Tag } from '@factorialco/deprecated-design-system'

import { lastPaymentExecution } from 'modules/banking/lib/paymentHelpers'

import type { Payment } from './types'

export const Transfers = ({ payment }: { payment: Payment }) => {
  const count = lastPaymentExecution(payment)?.transfersConnection.totalCount || 0
  return (
    <Tag type="grey" inline>
      {count}
    </Tag>
  )
}
